import { useSelector, useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"; 

const Contact = () => {
  const { t } = useTranslation();
  const appearance = useSelector((state) => state.appearance);
  const currentTheme = useSelector((state) => state.currentTheme);

  return (
    <>
      <div id="contact" className="contact-area ptb-100">
        <div className="container">
          <div
            className="saas-section-title"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-once="true"
            data-aos-delay="100"
          >
            <h2>{t("static.contact.title")}</h2>
            <div className="bar"></div>
          </div>

          <div
            className="contact-form"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-6 col-xs-6">
                <div className="contact-info-box contact-container">
                  <p>{t("static.contact.description")}</p>
                </div>
              </div>

              <div className="col-lg-6 col-md-6 col-xs-6">
                <div className="contact-info-box contact-container">
                  <h3>{t("static.contact.company")}</h3>
                  <p className="contact-container">
                    <b style={{color:currentTheme.primary}}>{t("static.contact.division")}</b>{" "}
                    <a
                      style={{ color: "#000" }}
                      href="mailto:BS@intech-mena.com"
                    >
                      {t("static.contact.email")}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>
        {`
          .contact-form {
             direction: ltr;
          }

          .contact-container {
            display: inline-block;
            direction: ${appearance.isRightToLeft ? "rtl" : "ltr"}  
          }

           @media screen and (max-width: 992px){
               
           }

          @media screen and (max-width: 767px) {
            .contact-form {
              background-color: #D97E11;
            }

            .contact-form::before {
              display: none;
            }

            .contact-form .contact-info-box {
              max-width: none;
              padding: 24px 16px;
            }

            .contact-form .contact-info-box h3,
            .contact-form .contact-info-box p,
            .contact-form .contact-info-box p b,
            .contact-form .contact-info-box p a {
              color: #ffffff !important;
            }
          }
          `}
      </style>
    </>
  );
};

export default Contact;
